


















































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Header extends Vue {
    private showHideHeaderNav() {
        if (this.$store.state.headerNavVisible === true) {
            this.$store.state.headerNavVisible = false;
        } else {
            this.$store.state.menuVisible = false;
            this.$store.state.headerNavVisible = true;
        }
    }

    private showHideMenu() {
        if (this.$store.state.menuVisible === true) {
            this.$store.state.menuVisible = false;
        } else {
            this.$store.state.headerNavVisible = false;
            this.$store.state.menuVisible = true;
        }
    }

    private showHideSidebar() {
        if (this.$store.state.mobileSidebarVisible === true) {
            this.$store.state.mobileSidebarVisible = false;
        } else {
            this.$store.state.mobileSidebarVisible = true;
        }
    }

    private logout() {
        this.$store.dispatch('destroyToken')
        .then((response) => {
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('username');
            localStorage.removeItem('displayName');
            localStorage.removeItem('role');
            localStorage.removeItem('tokenValidUntil');
            this.$router.push({ path: '/login' });
            this.$store.state.infoBoxText = 'Sie wurden erfolgreich abgemeldet.';
        }).catch((error) => {
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('username');
            localStorage.removeItem('displayName');
            localStorage.removeItem('role');
            localStorage.removeItem('tokenValidUntil');
            this.$router.push({ path: '/login' });
            this.$store.state.infoBoxText = 'Beim Abmelden trat ein Fehler auf.';
        });
    }
}
